module.exports = __webpack_public_path__ + "img/braingym-logo.45d2407.webp";